import Hint from '../components/Hint'
import { Page } from './types'
import Source from '../components/Source'

type InstallLicenseToolsProps = { os: string }

const render = ({ os }: InstallLicenseToolsProps) => {
    return <>
        <Hint title='Why download the license tools?'>
            When you install the full Gurobi software, it will include several tools for activating your license. There are scenarios where the full
            software suite is not needed, but you still need to activate a license. In this situation you can download a smaller package that just contains
            the Gurobi license tools instead.
        </Hint>
        <ul>
            <li>Go to our <a href="https://support.gurobi.com/hc/en-us/articles/360059842732-How-do-I-set-up-a-license-without-installing-the-full-Gurobi-package-">article about Gurobi license tools</a>.</li>
            <li>Look for the download for your operating system {os}</li>

        </ul>
        <Source href="https://support.gurobi.com/hc/en-us/articles/360059842732-How-do-I-set-up-a-license-without-installing-the-full-Gurobi-package-"/>
    </>
}

const InstallLicenseTools : Page<InstallLicenseToolsProps> = { key: 'install-license-tools', title: 'Install Gurobi license tools', render }

export default InstallLicenseTools